import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FileCopyOffSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FileCopyOffSVG;
